import { motion } from 'framer-motion'
import { ReactNode } from 'react'

interface ImageTextSectionProps {
    imageSrc: string
    imageAlt: string
    imagePosition?: 'left' | 'right'
    children: ReactNode
    className?: string
}

const ImageTextSection = ({
    imageSrc,
    imageAlt,
    imagePosition = 'right',
    children,
    className = '',
}: ImageTextSectionProps) => {
    return (
        <section className={`relative py-16 sm:py-20 ${className}`}>
            <div className="container-custom px-4 sm:px-6 lg:px-8">
                <div className={`flex flex-col gap-10 lg:gap-16 items-center ${imagePosition === 'right' ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}>
                    {/* Text Content */}
                    <div className="flex-1 w-full order-2 lg:order-none">
                        {children}
                    </div>

                    {/* Image Content */}
                    <motion.div
                        initial={{ opacity: 0, x: imagePosition === 'right' ? 50 : -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, ease: 'easeOut' }}
                        className="w-full lg:w-5/12 max-w-md mx-auto order-1 lg:order-none relative"
                    >
                        <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-primary-500/20 group">
                            <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 rounded-2xl pointer-events-none" />
                            <img
                                src={imageSrc}
                                alt={imageAlt}
                                loading="lazy"
                                className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>
                        {/* Decorative blob behind image */}
                        <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/10 to-purple-500/10 blur-2xl rounded-full -z-10" />
                    </motion.div>
                </div>
            </div>
        </section>
    )
}

export default ImageTextSection
